/* 热门车型栏 */
import React from 'react'
import classnames from 'classnames'
import Router from 'next/router'
import { sendTeaCommEvent, str } from 'lib/tea-analyze'
import { getSearchLink, getTypeParams } from './utils'
import dynamic from 'next/dynamic'

const TypeSelection = dynamic(
  () => import('./components/search-car-selection/type-select'),
  {
    ssr: false,
  }
)
const BrandSelect = dynamic(() =>
  import('./components/search-car-selection/brand-select')
)

interface INavList {
  name: string
  tabId: number
}
interface IProps {
  end: boolean
  mode: string
  keyword: string
  currTab: number
  sort_by?: number
  energy_type?: string
  brand_id?: string
  price_range?: string
  showCarSelection?: boolean
  searchReqId: string
  searchScene: string
  [key: string]: any
}
const ConditionList: INavList[] = [
  {
    name: '综合',
    tabId: 1,
  },
  {
    name: '找车',
    tabId: 6,
  },
  {
    name: '视频',
    tabId: 2,
  },
]

export const getTabName = (tabId: number) => {
  for (let i = 0; i < ConditionList.length; i++) {
    if (ConditionList?.[i]?.['tabId'] === tabId) {
      return ConditionList?.[i]?.['name']
    }
  }
  return ''
}

//0:全部 1:汽油 2:柴油 3:新能源
const energyType = ['全部', '汽油', '柴油', '新能源']
//0:热度最高 1:价格由低到高 2:价格由高到低
const sortBy = ['热度最高', '价格由低到高', '价格由高到低']
//0:价格不限 1:10万以下 2:10-15万 3:15-20万 4:20-25万 5:25-30万 6:30-40万 7:50万以上
const priceRange = [
  '价格不限',
  '10万以下',
  '10-15万',
  '15-20万',
  '20-25万',
  '25-30万',
  '30-40万',
  '50万以上',
]

const carConfig: {
  [key: string]: any
} = {
  brand_id: {
    key: 'brand_id',
    name: '品牌',
    selectComponent: BrandSelect,
  },
  price_range: {
    key: 'price_range',
    name: '价格',
    selectComponent: TypeSelection,
    props: {
      data: priceRange,
      column: 4,
    },
  },
  energy_type: {
    key: 'energy_type',
    name: '能源',
    selectComponent: TypeSelection,
    props: {
      data: energyType,
      column: 4,
    },
  },
}
/* eslint-disable react/destructuring-assignment */
export default function GlobalTab(props: IProps) {
  const { currTab } = props
  const sort_by = props?.sort_by || 0

  // 找到已经选择的
  const selectedData: any[] = []
  /* eslint-disable no-unused-expressions */
  Object.values(carConfig)?.forEach((item: any) => {
    const value = props[item?.key]
    const paramsValue = parseInt(getTypeParams(value), 10)

    if (paramsValue) {
      selectedData.push({
        key: item?.key,
        value: paramsValue,
        text: value?.split(',')?.[1],
      })
    }
  })

  // 如果加载完成 且 无选择任何条件 且 mode === 'fallback' 不展示筛选器
  let isFinalShow = props?.showCarSelection
  if (props?.showCarSelection && props?.end && props?.mode === 'fallback') {
    isFinalShow = false
  }

  /* 渲染选择条件 */
  function renderCondition() {
    return (
      <ul>
        {ConditionList.map((item: INavList, index: number) => (
          <li
            className={classnames({
              active: currTab === item.tabId,
            })}
            key={`${index}-${item.name}`}
            onClick={() => {
              sendTeaCommEvent('clk_event', {
                event_id: 'page_tab',
                sub_tab: item.name,
              })
              const link = getSearchLink({
                currTab: item.tabId,
              })
              // Router.push 的方式 埋点有问题
              window.location.href = link.as
            }}
          >
            <span>{item.name}</span>
          </li>
        ))}
        <style jsx>
          {`
            ul {
              width: 100%;
              height: 55px;
              padding-top: 24px;
              padding-bottom: 5px;
              font-size: 16px;
              color: #1f2129;
              border-bottom: 1px solid #e6e8f2;
            }
            li {
              display: inline-block;
              margin-right: 64px;
            }
            li:hover {
              cursor: pointer;
            }
            li:last-child {
              margin-right: 0;
            }
            .active {
              position: relative;
              font-size: 20px;
              font-weight: 600;
            }
            .active > span {
              color: #1a1a1a;
            }
            .active::after {
              content: '';
              position: absolute;
              left: 0;
              bottom: 0;
              display: inline-block;
              width: 100%;
              height: 3px;
              background-color: #ffcc32;
            }
          `}
        </style>
      </ul>
    )
  }

  const renderCarCondition = () => {
    if (!isFinalShow) {
      return ''
    }
    return (
      <div
        className="search-car-condition"
        data-log-view={str({
          event: 'show_event',
          event_id: 'aladdin_not_series_select_card',
          module_id: 'aladdin_not_series_select_card',
          rank: '-1',
          search_req_id: props?.searchReqId,
          search_scene: props?.searchScene,
          query_content: props?.keyword,
          sub_tab: '找车',
        })}
      >
        <ul className="type-condition fl">
          {Object.values(carConfig)?.map((item: any, i: number) => {
            const Comp = item?.selectComponent
            const value = props[item?.key]
            return (
              <li className="type-name" key={`condition-${i}`}>
                <span className="name">{item.name}</span>
                {Comp ? (
                  <Comp
                    {...item?.props}
                    typeKey={item.key}
                    value={value}
                    search_req_id={props?.searchReqId}
                    search_scene={props?.searchScene}
                    query_content={props?.keyword}
                  />
                ) : (
                  ''
                )}
              </li>
            )
          })}
        </ul>
        <ul className="sort-wrap fr">
          {sortBy.map((item: string, index: number) => (
            <li
              key={`sort-${index}`}
              className={classnames('sort-item', {
                active: sort_by === index,
              })}
              data-log-click={str({
                event: 'clk_event',
                event_id: 'aladdin_not_series_select_card_sort',
                module_id: 'aladdin_not_series_select_card',
                rank: '-1',
                search_req_id: props?.searchReqId,
                search_scene: props?.searchScene,
                query_content: props?.keyword,
                button_name: item,
                sub_tab: '找车',
              })}
              onClick={() => {
                if (sort_by === index) {
                  return
                }
                const link = getSearchLink({
                  sort_by: index,
                })
                Router.push(link.link, link.as)
              }}
            >
              {item}
            </li>
          ))}
        </ul>
        <style jsx>
          {`
            :global(.search-car-condition
                .type-name:hover
                .search-car-select-wrap) {
              display: block;
            }
            .search-car-condition {
              height: 40px;
              line-height: 40px;
              background: #fff;
              margin-top: 12px;
              padding: 0 16px;
              border-radius: 2px;
            }
            li {
              display: inline-block;
              font-size: 14px;
              color: #1f2129;
              cursor: pointer;
            }
            .sort-item:hover {
              color: #e65800;
            }
            .sort-item:first-child:before {
              display: none;
            }
            .sort-item:before {
              content: '';
              display: inline-block;
              margin: 0 12px;
              width: 1px;
              background: #c9cbd6;
              height: 14px;
              margin-bottom: -2px;
            }
            .active {
              color: #e62021;
            }
            .type-name {
              position: relative;
              padding-right: 60px;
            }
            .type-name:hover .name {
              color: #e65800;
            }
            .type-name:hover:after {
              border-left: 5px solid #e65800;
              transform: rotate(-90deg);
            }
            .type-name:after {
              content: '';
              width: 0;
              height: 0;
              top: -1px;
              display: inline-block;
              border-top: 4px solid transparent;
              border-bottom: 4px solid transparent;
              border-left: 5px solid #1f2129;
              margin-left: 6px;
              transition: all 0.1s ease-in-out;
              transform: rotate(90deg);
            }
          `}
        </style>
      </div>
    )
  }

  const renderSelected = () => {
    if (!isFinalShow) {
      return ''
    }
    if (currTab !== 6) {
      return ''
    }

    if (!selectedData?.length) {
      return null
    }

    return (
      <div className="selected-condition">
        <ul className="list-wrap">
          {selectedData?.map((item: any) => {
            return (
              <li>
                <span>{item.text}</span>
                <span
                  className="icon-dislike-ic delete-icon"
                  onClick={() => {
                    const params: {
                      [key: string]: any
                    } = {}
                    params[item.key] = 'DELETE_KEY'
                    const link = getSearchLink(params)
                    Router.push(link.link, link.as)
                  }}
                />
              </li>
            )
          })}
        </ul>
        <style jsx>
          {`
            .selected-condition {
              height: 40px;
              background: #fff;
              padding: 8px 16px;
            }
            li {
              float: left;
              margin-right: 6px;
              padding: 0 0 0 12px;
              height: 24px;
              border-radius: 2px;
              background-color: #e6e8f2;
              line-height: 24px;
              font-size: 12px;
              color: #1f2129;
            }
            .delete-icon {
              padding: 0 10px 0 5px;
              cursor: pointer;
            }
            span {
              vertical-align: middle;
            }
          `}
        </style>
      </div>
    )
  }

  return (
    <div className="models">
      {renderCondition()}
      {renderCarCondition()}
      {renderSelected()}
      <style jsx>
        {`
          .models {
            border-top: 0;
            width: 100%;
          }
        `}
      </style>
    </div>
  )
}
